'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TurnstileToken$() {
  this.ccY = null;
  this.ccZ = false;
}
export { $c_Lpresto_types$TurnstileToken$ as $c_Lpresto_types$TurnstileToken$ };
$p = $c_Lpresto_types$TurnstileToken$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TurnstileToken$;
/** @constructor */
function $h_Lpresto_types$TurnstileToken$() {
}
export { $h_Lpresto_types$TurnstileToken$ as $h_Lpresto_types$TurnstileToken$ };
$h_Lpresto_types$TurnstileToken$.prototype = $p;
$p.cJs = (function() {
  if ((!this.ccZ)) {
    this.ccY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.ccZ = true;
  }
  return this.ccY;
});
var $d_Lpresto_types$TurnstileToken$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TurnstileToken$, "presto.types$TurnstileToken$", ({
  a2l: 1,
  D: 1
}));
export { $d_Lpresto_types$TurnstileToken$ as $d_Lpresto_types$TurnstileToken$ };
var $n_Lpresto_types$TurnstileToken$;
function $m_Lpresto_types$TurnstileToken$() {
  if ((!$n_Lpresto_types$TurnstileToken$)) {
    $n_Lpresto_types$TurnstileToken$ = new $c_Lpresto_types$TurnstileToken$();
  }
  return $n_Lpresto_types$TurnstileToken$;
}
export { $m_Lpresto_types$TurnstileToken$ as $m_Lpresto_types$TurnstileToken$ };
//# sourceMappingURL=presto.types$-Turnstile-Token$.js.map
